import React from 'react';
import { Tag } from 'antd';
import { FormattedMessage } from 'react-intl';

type Tier = 'clean' | 'suspect' | 'flagged' | 'quarantined' | null | undefined;

interface TierBadgeProps {
    tier: Tier;
}

const TIER_COLORS: Record<NonNullable<Tier>, string> = {
    clean: 'green',
    suspect: 'gold',
    flagged: 'orange',
    quarantined: 'red',
};

export const TierBadge: React.FC<TierBadgeProps> = ({ tier }) => {
    if (!tier) {
        return <span style={{ color: '#999' }}>—</span>;
    }
    return (
        <Tag color={TIER_COLORS[tier]} style={{ margin: 0 }}>
            <FormattedMessage id={`responseIntegrity.tier.${tier}`} />
        </Tag>
    );
};
